import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonImg, IonCheckbox } from '@ionic/react';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

export function DeleteZasavaPublicModal(props) {

    let zasava_context = useContext(Auth_Zasava_Context);

    let [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    //let [merchantAccountID, setMerchantAccountID] = useState(props.data.data_merchantID);


    function submitDeletionRequest()
    {


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '9010Z',
                sessionID: sessionID
            })
        }


        
        fetch(baseURL+'/admin_zsava_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function closeModalHandler(event) {

        props.closeModal(event);
    }

    //alert('Inside Modal_Delete_Zasava_Public');

    return (
        <React.Fragment>            
        {props.openModal == true ?
        (
            <div>
            {/* {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))} */}

            <IonModal isOpen={ props.openModal }>

                <IonText> Delete Zasava Public </IonText>
                <IonGrid >
                    <IonRow >   
                        <IonCol>
                            <IonButton onClick={submitDeletionRequest}> Submit Zasava Deletion Request </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
            </IonModal>            
        </div>
        ) : null }
    </React.Fragment>
    )
}